module.exports = __webpack_public_path__ + "img/productos.83039028.jpeg";